import * as React from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import 'src/components/project-billing/dialogs/RefreshDataDialog.css';

interface IBuildPayrollConfirmDialogProps {
    dialogName: string;
    hideDialog: () => void;
    building: boolean;
    message?: string;
    onConfirm: (buildCommissions: boolean) => void;
}

// Mirrors the real Oracle "Generate" canvas (block GENERATE, oid 462) exactly - three stacked
// buttons, no text fields. Both button triggers (oids 466/469) run the identical Check_Staffing/
// Duplicate_MultiBilling-guarded Build_Pay_History call; the only difference is the 3rd
// (build_payroll/buildCommissions) argument - false for "No Commissions", true for "and
// Commissions" (the Oracle triggers' own commission-building calls are all commented out as of a
// 2022-03-08 change, so "and Commissions" doesn't actually rebuild commissions today either - it
// only flips that flag, same as here). `message` surfaces a blocked Check_Staffing/
// Duplicate_MultiBilling guard - unlike Oracle's own silent no-op, the dialog stays open with the
// same alert text so the user knows why nothing happened instead of just... nothing happening.
const BuildPayrollConfirmDialog = (props: IBuildPayrollConfirmDialogProps) => {
    return (
        <Dialog title="Generate" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '24%' }}>
            <div
                className="metallic-dialog-body"
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', padding: '20px' }}
            >
                {!!props.message && (
                    <div style={{ color: 'red', textAlign: 'center' }}>{props.message}</div>
                )}
                <Button
                    className="shiny-metal-button"
                    style={{ whiteSpace: 'nowrap', width: '75%' }}
                    text={props.building ? 'Building...' : 'Generate Payroll - No Commissions'}
                    disabled={props.building}
                    onClick={() => props.onConfirm(false)}
                />
                <Button
                    className="shiny-metal-button"
                    style={{ whiteSpace: 'nowrap', width: '75%' }}
                    text={props.building ? 'Building...' : 'Generate Payroll and Commissions'}
                    disabled={props.building}
                    onClick={() => props.onConfirm(true)}
                />
                <Button
                    className="shiny-metal-button"
                    style={{ whiteSpace: 'nowrap', width: '75%' }}
                    text="Cancel"
                    disabled={props.building}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default BuildPayrollConfirmDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/employeePayroll/BuildPayrollConfirmDialog.tsx